var _rect, _path, _path2, _path3, _g, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSharePointCircle({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 78,
    viewBox: "0 0 78 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.314941,
    y: 0.611328,
    width: 77,
    height: 77,
    rx: 38.5,
    transform: "rotate(-0.454799 0.314941 0.611328)",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1578_6330)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.3538 46.6172C46.3878 46.6172 52.9006 39.9714 52.9006 31.7734C52.9006 23.5755 46.3878 16.9297 38.3538 16.9297C30.3197 16.9297 23.8069 23.5755 23.8069 31.7734C23.8069 39.9714 30.3197 46.6172 38.3538 46.6172Z",
    fill: "url(#paint0_linear_1578_6330)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3694 52.8672C58.1349 52.8672 63.6194 47.2707 63.6194 40.3672C63.6194 33.4636 58.1349 27.8672 51.3694 27.8672C44.6039 27.8672 39.1194 33.4636 39.1194 40.3672C39.1194 47.2707 44.6039 52.8672 51.3694 52.8672Z",
    fill: "url(#paint1_linear_1578_6330)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1578_6330",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 29,
    y: 23,
    width: 21,
    height: 38
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M49.8381 50.5234C49.8381 56.1327 45.382 60.6797 39.885 60.6797C34.388 60.6797 29.9319 56.1327 29.9319 50.5234C29.9319 44.9144 29.9319 23.1797 29.9319 23.1797L49.8381 23.1797C49.8381 23.1797 49.8381 46.9278 49.8381 50.5234Z",
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1578_6330)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.885 60.6797C45.382 60.6797 49.8381 56.1326 49.8381 50.5234C49.8381 44.9143 45.382 40.3672 39.885 40.3672C34.3881 40.3672 29.9319 44.9143 29.9319 50.5234C29.9319 56.1326 34.3881 60.6797 39.885 60.6797Z",
    fill: "url(#paint2_linear_1578_6330)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.3381 32.5547C25.3381 29.9658 27.3948 27.8672 29.9319 27.8672L40.6506 27.8672C43.1878 27.8672 45.2444 29.9658 45.2444 32.5547L45.2444 51.3047C45.2444 53.8936 43.1878 55.9922 40.6506 55.9922L25.3381 55.9922L25.3381 32.5547Z",
    fill: "black",
    fillOpacity: 0.3
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M39.1194 24.7422L17.6819 24.7422C15.9905 24.7422 14.6194 26.1413 14.6194 27.8672L14.6194 49.7422C14.6194 51.4681 15.9905 52.8672 17.6819 52.8672L39.1194 52.8672C40.8108 52.8672 42.1819 51.4681 42.1819 49.7422L42.1819 27.8672C42.1819 26.1413 40.8108 24.7422 39.1194 24.7422Z",
    fill: "url(#paint3_linear_1578_6330)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5256 42.1217C34.5256 39.6994 32.9334 38.6302 29.6205 37.3863C27.0267 36.4042 26.4103 36.1205 26.4103 35.1822C26.4103 34.3747 27.1808 33.8291 28.4905 33.8291C29.826 33.8291 31.0843 34.2873 32.4969 35.073L33.935 32.4761C32.4197 31.5159 30.622 30.9922 28.4392 30.9922C25.1006 30.9922 22.7122 32.738 22.7122 35.4003C22.7122 38.1281 24.6126 39.0011 27.7971 40.1577C30.3395 41.0742 30.8275 41.5325 30.8275 42.34C30.8275 43.3002 29.9287 43.7803 28.5162 43.7803C26.8469 43.7803 25.3831 43.1911 23.9192 42.2308L22.2756 44.7186C24.0733 45.9844 26.3076 46.6172 28.5933 46.6172C32.0346 46.6172 34.5256 44.9586 34.5256 42.1217Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1578_6330",
    x1: 23.8069,
    y1: 31.7734,
    x2: 55.3251,
    y2: 31.7734,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#103A3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#116B6E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1578_6330",
    x1: 42.1819,
    y1: 34.1172,
    x2: 63.8304,
    y2: 46.2404,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D9097"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#29BBC2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1578_6330",
    x1: 32.9944,
    y1: 47.3984,
    x2: 49.9531,
    y2: 54.9528,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#28A6B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31D6EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1578_6330",
    x1: 14.6194,
    y1: 38.8047,
    x2: 44.4788,
    y2: 38.8047,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#105557"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#116B6E"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1578_6330"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 49,
    height: 50,
    fill: "white",
    transform: "translate(14.6194 13.8047)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSharePointCircle);
export default __webpack_public_path__ + "static/media/sharePointCircle.0a37328bfa0b1d3346862a8423a7d111.svg";
export { ForwardRef as ReactComponent };